// extracted by mini-css-extract-plugin
export default {"quickNav":"Accueil_quickNav__GGyGL","quickButton":"Accueil_quickButton__OzttU"};